function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1247",
  "data-name": "Group 1247",
  transform: "translate(-5376.054 -4554.603)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1246",
  "data-name": "Group 1246",
  transform: "translate(5376.055 4554.603)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_1",
  "data-name": "Ellipse 1",
  transform: "translate(0 0)",
  fill: "#fff",
  stroke: "#00e5ae",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("circle", {
  cx: 8.667,
  cy: 8.667,
  r: 8.667,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 8.667,
  cy: 8.667,
  r: 7.667,
  fill: "none"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Path_755",
  "data-name": "Path 755",
  d: "M14.432,11.336,9.927,16.166,7.384,13.633,6,15.018l3.927,3.927,5.89-6.215Z",
  transform: "translate(5373.813 4548.13)",
  fill: "#3458a4",
  stroke: "rgba(0,0,0,0)",
  strokeLinecap: "round",
  strokeWidth: 1
}));

var SvgCheck = function SvgCheck(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.334,
    height: 17.334,
    viewBox: "0 0 17.334 17.334",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check.271df316.svg";
export { ForwardRef as ReactComponent };